import { useEffect, useState } from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { MultiSelect } from 'primereact/multiselect';

import { useUpdateDonorScheduleTransaction } from '@/services/fresh-shipment/hooks';

import { FIELD_NAMES, PREDICTION_COMMENTS_OPTIONS } from '../utils/constants';

import './PredictionCommentsDropdown.css';

export const PredictionCommentsDropdown = (props: ICellRendererParams) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const { mutateAsync: updateDonorSchedule } =
    useUpdateDonorScheduleTransaction();

  useEffect(() => {
    if (props.value) {
      setSelectedOptions(props.value.split(', '));
    }
  }, [props.value]);

  const updateCellValue = (options: string[]) => {
    const newValue = options.join(', ');
    props?.setValue?.(newValue);
  };

  const handleChange = (e: { value: string[] }) => {
    setSelectedOptions(e.value);
    updateCellValue([...e.value]);

    updateDonorSchedule({
      id: props?.data?.fertilizationId,
      field: FIELD_NAMES.FRESH_SHIPMENT_COMMENTS,
      value: e.value?.join(', '),
      updatePredictedComments: true,
      isIvf: props?.data?.isIvf,
    });
  };

  return (
    <div className="prediction-comments-dropdown__wrapper">
      <MultiSelect
        value={selectedOptions}
        options={PREDICTION_COMMENTS_OPTIONS}
        onChange={handleChange}
        showSelectAll={true}
        tooltip={selectedOptions.join(', ')}
        className="prediction-comments-dropdown"
        style={{
          width: '70px',
          height: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      />
    </div>
  );
};
